import { DOMHelper } from "../Helpers/DOMHelper.js";

export class ProgressSteps {
    constructor(app) {
        this.app = app;
        this.parentId = app.config.elementId;
        this.classAt = "progress-steps-section";
        this.steps = [];
        this.currentStep = -1;
    }

    init(containerElement) {
        containerElement.insertAdjacentHTML("beforeend", this.addHtml());
    }

    addHtml() {
        if (this.app.isLampedodge()) {
            return this.addHtmlLampedodge();
        }

        let stepNumber = 0;
        let accsSection = "";
        if (this.app.dealPage.isAccessoriesSectionAllowed()) {
            stepNumber += 1;
            accsSection = `<div class="pm-step active" data-target="1">
                <div class="pm-step-circle" data-target="1"><span data-target="1">${stepNumber}</span></div>
                <div class="pm-step-bar-left"></div>
                <div class="pm-step-bar-right"></div>
            </div>`;
        }
        let tradeInSection = "";
        if (this.app.dealPage.getTradeInEnable()) {
            stepNumber += 1;
            tradeInSection = `<div class="pm-step" data-target="2">
                <div class="pm-step-circle" data-target="2"><span data-target="2">${stepNumber}</span></div>
                <div class="pm-step-bar-left"></div>
                <div class="pm-step-bar-right"></div>
            </div>`;
        }
        stepNumber += 1;
        let yourPaymentSection = `<div class="pm-step" data-target="3">
            <div class="pm-step-circle" data-target="3"><span data-target="3">${stepNumber}</span></div>
            <div class="pm-step-bar-left"></div>
            <div class="pm-step-bar-right"></div>
        </div>`;
        stepNumber += 1;
        let contactInformationSection = `<div class="pm-step" data-target="4">
            <div class="pm-step-circle" data-target="4"><span data-target="4">${stepNumber}</span></div>
            <div class="pm-step-bar-left"></div>
            <div class="pm-step-bar-right"></div>
        </div>`;
        let stepper = `<div class="pm-stepper-horizontal orange">
            ${accsSection}
            ${tradeInSection}
            ${yourPaymentSection}
            ${contactInformationSection}
        </div>`;
        return stepper;
    }

    addHtmlLampedodge() {
        // Lampedodge step order: Cash Down & Credit → Payment → Trade-In → Contact
        // data-target values must match the trigger-element data-index values set by
        // rearrangeSectionsForLampedodge() in DealPage.js
        const steps = [1, 2, 3, 4];
        const dots = steps.map((n, i) => `
            <div class="pm-step${i === 0 ? ' active' : ''}" data-target="${n}">
                <div class="pm-step-circle" data-target="${n}"><span data-target="${n}">${n}</span></div>
                <div class="pm-step-bar-left"></div>
                <div class="pm-step-bar-right"></div>
            </div>`).join('');
        return `<div class="pm-stepper-horizontal orange">${dots}</div>`;
    }

    getSelector(selector) {
        return this.app.getSelector("#" + this.parentId + " " + selector);
    }
}